import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var create_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M16 11.2h-3.2V8h-1.6v3.2H8v1.6h3.2V16h1.6v-3.2H16z" }) });
export {
  create_default as default
};
//# sourceMappingURL=create.js.map
